import React from "react";
import { Helmet } from "react-helmet-async";
import { Navbar, Footer, Breadcrumbs } from "../../components/shared";
import { useCheckAccess } from "../../utils/Utilities";
import PinCodeLookup from "./PinCodeLookup";

const AddressAreaCreate = () => {
  useCheckAccess('AddressRW'); // Check if the user is logged in (if no user data, redirect to login)
  return (
    <>
      <Navbar />
      <Helmet>
        <title>ஸ்ரீ பொன்னாச்சி அம்மன் திருக்கோவில்கள் | முகவரிப் பகுதி உருவாக்கப் பக்கம்</title>
        <link rel="canonical" href="/address-area/create" />
      </Helmet>
      <Breadcrumbs /><br />
      <PinCodeLookup />
      <Footer />
    </>
  );
};
export default AddressAreaCreate;